const es = {
    common: {
        cancel: 'Cancelar',
        close: 'Cerrar',
        goBack: 'Volver',
        settings: 'Configuración',
        signOut: 'Cerrar sesión',
        ok: 'OK',
        loading: 'Cargando…',
        tryAgain: 'Intentar de nuevo',
        offline: 'Sin conexión'
    },
    loading: {
        ariaLabel: 'Cargando'
    },
    login: {
        title: 'Iniciar sesión en 7punches',
        subtitle: 'Por favor usa tu cuenta de 7shifts',
        signIn: 'Iniciar sesión',
        redirecting: 'Redirigiendo…',
        errorFallback: 'No se puede iniciar la sesión'
    },
    callback: {
        failed: 'Error al iniciar sesión',
        tryAgain: 'Intentar de nuevo'
    },
    selection: {
        title: 'Selecciona tu ubicación',
        companyLabel: 'Empresa',
        companyPlaceholder: 'Selecciona una empresa',
        locationLabel: 'Ubicación',
        locationPlaceholder: 'Selecciona una ubicación',
        next: 'Siguiente'
    },
    footer: {
        poweredBy: 'Desarrollado por 7shifts'
    },
    pinGrid: {
        title: 'Ingresa tu ID de fichaje',
        clear: 'BORRAR',
        backspace: 'Retroceso',
        punch: 'Fichar',
        srNoDigits: 'No se ingresaron dígitos',
        srDigitCountSingular: '1 dígito ingresado',
        srDigitCountPlural: '{count} dígitos ingresados'
    },
    tips: {
        title: 'Ingresar propinas',
        subtitle: '¿Cuánto ganaste en propinas en este turno?',
        amountLabel: 'Monto de propina',
        validationError: 'Por favor ingresa un monto de propina válido.',
        submit: 'Enviar',
        confirm: 'Confirmar',
        skip: 'Omitir',
        keypadAriaLabel: 'Teclado de monto de propina'
    },
    department: {
        title: 'Selecciona un departamento'
    },
    role: {
        selectTitle: 'Selecciona un rol',
        confirmTitle: 'Confirma tu rol'
    },
    attestation: {
        confirm: 'Confirmar'
    },
    healthCheck: {
        unavailableTitle: 'Control de salud no disponible',
        unavailableBody:
            'No se pudieron cargar las preguntas del control de salud. Por favor intenta de nuevo o cancela.',
        dismiss: 'Descartar',
        submitFallback: 'Enviar'
    },
    punchResult: {
        clockIn: {
            heading: '¡Fichaje de entrada!',
            subtitle: '¡Bienvenido/a, {name}!'
        },
        clockOut: {
            heading: '¡Fichaje de salida!',
            subtitle: '¡Hasta luego, {name}!'
        },
        breakStart: {
            heading: 'Descanso iniciado',
            subtitle: '¡Disfruta tu descanso, {name}!'
        },
        breakEnd: {
            heading: '¡Bienvenido/a de nuevo!',
            subtitle: '¡De vuelta al trabajo, {name}!'
        },
        ok: 'OK ({countdown})'
    },
    offlinePunchRecorded: {
        title: 'Fichaje sin conexión registrado',
        subtitle:
            'Sincronizaremos esto automáticamente en cuanto vuelvas a estar en línea.',
        ok: 'OK ({countdown})'
    },
    error: {
        defaultHeader: 'Algo salió mal',
        invalidPunchId: {
            header: 'ID de fichaje incorrecto',
            body: 'Por favor intenta de nuevo.'
        },
        breakTooShort: {
            header: 'Regresaste muy pronto',
            body: 'Tu descanso no ha alcanzado la duración mínima.'
        },
        healthCheckFailed: {
            header: 'No puedes fichar debido al control de salud',
            body: 'Según tus respuestas, no puedes completar tu turno. Por favor contacta a tu gerente.'
        },
        notAssignedToLocation: {
            header: 'No estás asignado a esta ubicación',
            body: 'Por favor contacta a tu gerente para que te asignen a esta ubicación antes de fichar.'
        },
        clockInTooEarly: {
            header: 'Es demasiado pronto para fichar',
            body: 'Aún no puedes fichar. Por favor intenta de nuevo más cerca de la hora de inicio de tu turno.'
        },
        shiftNotScheduled: {
            header: 'No estás programado para trabajar',
            body: 'Parece que no tienes un turno programado hoy. Por favor contacta a tu gerente.'
        },
        network: {
            header: 'Sin conexión',
            body: 'No se puede conectar a 7shifts.com. Por favor verifica tu conexión a internet e intenta de nuevo.'
        },
        serverOrUnknown: {
            header: 'Algo salió mal',
            body: 'Ha ocurrido un error desconocido. Por favor intenta de nuevo.'
        }
    },
    userStatus: {
        greeting: '¡Hola, {firstName}!',
        haveAGreatShift: 'Que tengas un excelente turno hoy.',
        yourShifts: 'Tus turnos',
        currentShift: 'Turno actual',
        punchedIn: 'Fichado',
        onBreak: 'En descanso',
        timeOnShift: 'tiempo en turno',
        onBreakElapsed: '{elapsed} en descanso',
        breakEndsAt: 'termina a las {time}',
        noScheduledShifts: 'Sin turnos programados',
        noShiftsToday: 'No tienes turnos hoy.'
    },
    account: {
        noCompanies: 'No se encontraron empresas para esta cuenta.',
        failedToLoadCompanies: 'Error al cargar las empresas.',
        noLocations: 'No se encontraron ubicaciones para esta empresa.',
        failedToLoadLocations: 'Error al cargar las ubicaciones.',
        failedToLoadAccount: 'Error al cargar la cuenta.'
    },
    settings: {
        changeLocation: 'Cambiar ubicación',
        logout: 'Cerrar sesión',
        theme: 'Tema',
        themeLight: 'Claro',
        themeDark: 'Oscuro',
        themeUrlLocked:
            'El tema fue establecido inicialmente por el parámetro de URL.',
        verifyLogoutTitle: 'Confirmar cierre de sesión',
        verifyLogoutSubmit: 'Cerrar sesión',
        verifyChangeLocationTitle: 'Confirmar cambio de ubicación',
        verifyChangeLocationSubmit: 'Cambiar ubicación',
        verifyError: 'ID de fichaje incorrecto. Inténtalo de nuevo.'
    },
    inactivity: {
        title: '¿Sigues ahí?',
        subtitle: 'No has tocado la pantalla en un momento.',
        stayActive: '¡Todavía estoy aquí!',
        signOut: 'Cerrar sesión',
        signOutCountdown: 'Cerrar sesión ({countdown})'
    },
    sessionExpired: {
        title: 'Sesión expirada',
        message:
            'Se ha cerrado su sesión por inactividad. Por favor inicia sesión de nuevo.',
        messageWebview:
            'Se ha cerrado su sesión por inactividad. Por favor usa la aplicación para iniciar sesión de nuevo.'
    },
    externalUser: {
        signingIn: 'Iniciando sesión…',
        done: '¡Listo!'
    },
    offline: {
        banner: {
            heading: 'Sin conexión a Internet',
            body: 'Aún puedes registrar tu entrada y salida, pero otras funciones están limitadas hasta que vuelvas a estar en línea.',
            timeLimitPrefix: 'Puedes fichar sin conexión durante ',
            daysSingular: '1 día más',
            daysPlural: '{count} días más',
            timeLimitSuffix:
                '. Por favor, vuelve a conectarte pronto para seguir usando el reloj de tiempo.'
        },
        lockout: {
            heading: 'Límite sin conexión alcanzado',
            body: 'No puedes fichar entrada ni salida hasta que este dispositivo se vuelva a conectar a Internet.'
        },
        intermediate: {
            greeting: '¡Hola!',
            haveAGreatShift: 'Que tengas un gran turno hoy.',
            heading: 'Estás sin conexión',
            body: 'Aún puedes registrar tu entrada y salida. Sincronizaremos tus fichajes tan pronto como vuelvas a estar en línea.',
            punchButton: 'Fichar sin conexión'
        }
    }
} as const;

export default es;
